import React from 'react';
import { useTheme } from './ThemeContext';
import { Link } from 'react-router-dom'; // Import Link
import './Footer.css';

const Footer = () => {
  const { darkMode } = useTheme();

  return (
    <footer className={`footer ${darkMode ? 'dark' : 'light'}`}>
      <div className="footer-content">
        <p>© 2025 Charlotte Student Hub. All rights reserved.</p>
        <div className="footer-links">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <a href="https://mail.google.com/mail/?view=cm&fs=1&to=shivangpatel2050@gmail.com&su=Support Request">Contact Us</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;